import type { MessageSubject } from '@/types/generated/public_api'

export type WebSocketTransportLane = 'bulk' | 'critical'

export function combinedWebSocketConnectionStatus(
  bulkStatus: string,
  criticalStatus: string
): string {
  if (bulkStatus === 'OPEN' && criticalStatus === 'OPEN') return 'OPEN'
  return criticalStatus !== 'OPEN' ? criticalStatus : bulkStatus
}

const CRITICAL_SUBJECT_KEYS = new Set<keyof MessageSubject>([
  'account',
  'accountStream',
  'execution',
  'serviceNotifications',
])

const CRITICAL_LISTENER_KEYS = new Set([
  'account',
  'accountStream',
  'execution',
  'notification',
  'serviceNotifications',
])

export function messageSubjectKey(channel: Partial<MessageSubject>): keyof MessageSubject | null {
  for (const key of Object.keys(channel) as Array<keyof MessageSubject>) {
    if (channel[key] !== undefined) return key
  }
  return null
}

export function transportLaneForChannel(channel: Partial<MessageSubject>): WebSocketTransportLane {
  const key = messageSubjectKey(channel)
  return key !== null && CRITICAL_SUBJECT_KEYS.has(key) ? 'critical' : 'bulk'
}

export function transportLaneForListener(channelKey: string): WebSocketTransportLane {
  return CRITICAL_LISTENER_KEYS.has(channelKey) ? 'critical' : 'bulk'
}

export function partitionChannelsByTransport(
  channels: readonly Partial<MessageSubject>[]
): Record<WebSocketTransportLane, Partial<MessageSubject>[]> {
  const partitioned: Record<WebSocketTransportLane, Partial<MessageSubject>[]> = {
    bulk: [],
    critical: [],
  }
  for (const channel of channels) {
    partitioned[transportLaneForChannel(channel)].push(channel)
  }
  return partitioned
}
